var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnailBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 26.6668C4.13268 26.6668 3.66602 26.4668 3.26602 26.0668C2.86602 25.6668 2.66602 25.2002 2.66602 24.6668V7.3335C2.66602 6.80016 2.86602 6.3335 3.26602 5.9335C3.66602 5.5335 4.13268 5.3335 4.66602 5.3335H11.3327V26.6668H4.66602Z",
    fill: "#25CBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 26.6668V5.3335H27.334C27.8673 5.3335 28.334 5.5335 28.734 5.9335C29.134 6.3335 29.334 6.80016 29.334 7.3335V24.6668C29.334 25.2002 29.134 25.6668 28.734 26.0668C28.334 26.4668 27.8673 26.6668 27.334 26.6668H13.334Z",
    fill: "#222343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailBar);
export default __webpack_public_path__ + "static/media/thumbnail-bar.d52d24363823f9e755daf40c69a2657a.svg";
export { ForwardRef as ReactComponent };